import { render, staticRenderFns } from "./conversationDetail.vue?vue&type=template&id=189f2f0b"
import script from "./conversationDetail.vue?vue&type=script&lang=js"
export * from "./conversationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports